export class NotificationDataBuilder {
  constructor(props) {
    this.notificationData = props?.notificationData
    this.type = props.notificationData?.type
    this.subType = props.notificationData.subType
    this.sourceId = props.notificationData?.sourceId
    this.variablesForUse = { ...(props.variablesForUse || {}) }
    this.onClick = () => {
      console.log('This type of notification is not handled yet')
    }
  }
}
